import { RentalPropertyDto } from "./RentalPropertyDto";

export class GetRentalPropertiesResultDto {
    constructor(message: string, success: boolean) {
        this.message = message;
        this.success = success;
    }

    rentalProperties: RentalPropertyDto[];
    message: string;
    success: boolean;
}